import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { EDRReport } from "../../../components/Reports/EDRReport";

export interface IEDRReportPage {}

export const EDRReportPage: FC<IEDRReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="EDR Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<EDRReport />}
		/>
	);
};
